import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-203" data-mp="17nx8seosfmgu">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-204" data-mp="17lb2eidmvd07">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E] uppercase" data-id="element-205" data-mp="1me4kmbkai78k">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-206" data-mp="top6ve18q08y">
          <h3 className="text-2xl font-bold mb-3" data-id="element-207" data-mp="tnw7iy4m2d0u">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-208" data-mp="opuogd76qdpd">
            <li className="flex items-center font-bold" data-id="element-209" data-mp="12oca85dj5g4n">
              <span className="text-yellow-400 mr-3" data-id="element-210" data-mp="12pvojqfmlh3s">•</span> Megapack Inclusión
              Educativa (1° a 6° grado)
            </li>
            <li className="flex items-center" data-id="element-211" data-mp="2e3hehdtb7mqd">
              <span className="text-yellow-400 mr-3" data-id="element-212" data-mp="2e26apdzv6ez9">•</span> BONUS 1: Kit de
              Regulación Emocional
            </li>
            <li className="flex items-center" data-id="element-213" data-mp="2a3yt6gxkt9n0">
              <span className="text-yellow-400 mr-3" data-id="element-214" data-mp="1ndi4akfbaymp">•</span> BONUS 2: Tableros
              Visuales y Apoyos
            </li>
            <li className="flex items-center" data-id="element-215" data-mp="1saqiyb194kj7">
              <span className="text-yellow-400 mr-3" data-id="element-216" data-mp="1wdn6mg5nf6u0">•</span> BONUS 3: Atención,
              Memoria y Foco
            </li>
            <li className="flex items-center" data-id="element-217" data-mp="21cztv20fmfx4">
              <span className="text-yellow-400 mr-3" data-id="element-218" data-mp="21anf0xpz0loa">•</span> BONUS 4: Cuaderno
              de Autonomía
            </li>
            <li className="flex items-center" data-id="element-219" data-mp="18o2dx5jp0v7j">
              <span className="text-yellow-400 mr-3" data-id="element-220" data-mp="18ovmmc27pusb">•</span> BONUS 5:
              Planificador Docente Inclusivo
            </li>
            <li className="flex items-center font-bold text-yellow-400" data-id="element-221" data-mp="1dl2krioda1zp">
              <span className="mr-3" data-id="element-222" data-mp="1ifgihrqi4l7j">👑</span> BONUS PREMIUM: Juegos Pedagógicos
              Inclusivos
            </li>
            <li className="flex items-center font-bold text-yellow-400" data-id="element-223" data-mp="kwf5c3qau6u2">
              <span className="mr-3" data-id="element-224" data-mp="pw9thziowibf">👑</span> BONUS PREMIUM: Taller de Alimentación
              Saludable
            </li>
            <li className="flex items-center font-bold text-yellow-400" data-id="element-225" data-mp="1t6dy0xpjnup1">
              <span className="mr-3" data-id="element-226" data-mp="1o8m6w5wq4clw">👑</span> BONUS PREMIUM: Pausas Activas y
              Regulación en el Aula
            </li>
            <li className="flex items-center font-bold text-yellow-400" data-id="element-227" data-mp="222wrcb1otkm5">
              <span className="mr-3" data-id="element-228" data-mp="1xzqm96qb9zh9">👑</span> BONUS PREMIUM: Cuadernillo de
              Matemática para Discalculia
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-229" data-mp="15b2s0lnl3zrk">
          <h3 className="text-2xl font-bold mb-3" data-id="element-230" data-mp="15cmcypk6qyzo">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-231" data-mp="1jb3ycgmmbzef">
            <li className="flex items-start" data-id="element-232" data-mp="1eb7qu7epppu4">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-233" data-mp="1eag7buye3ik7" />
              <span data-id="element-234" data-mp="2uog2ksmaik14">Más de 600 actividades adaptadas listas para usar</span>
            </li>
            <li className="flex items-start" data-id="element-235" data-mp="2pr63el93mu03">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-236" data-mp="2psh94qm3ubtu" />
              <span data-id="element-237" data-mp="2y5u40yid173f">Material visual, accesible y sin sobrecarga cognitiva</span>
            </li>
            <li className="flex items-start" data-id="element-238" data-mp="32ajweddt83jl">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-239" data-mp="2o9h9xziwkr85" />
              <span data-id="element-240" data-mp="2t8an1qua2g7s">
                Recursos multinivel para distintos ritmos de aprendizaje
              </span>
            </li>
            <li className="flex items-start" data-id="element-241" data-mp="3gxmsqgqec65c">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-242" data-mp="3gzzlzq1lu2xp" />
              <span data-id="element-243" data-mp="3lwg5u81rtv4z">
                Ahorro de horas en planificación y adaptación de tareas
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}